export const errors = {
  networkError: {error: 'Error', message: 'Something went wrong.'},
  tokenExpireError: {
    error: 'Invalid token',
    message: 'User token expire, please login again.',
  },
};
